import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '../ui/Button';
import useTextToSpeech from '../../hooks/useTextToSpeech.js';
import { calculateReadingTime } from '../../utils/textHelper';
import { useMemo } from 'react';

const ResultHeader = ({ content, print = false }) => {
	const { t, i18n } = useTranslation();
	const { speak, cancel, isSpeaking } = useTextToSpeech();
	const estimatedReadingTime = useMemo(() => calculateReadingTime(content), [content]);

	const isBrowserSupported = 'speechSynthesis' in window;

	return (
		<div className='flex items-center justify-between py-6 border-t border-tertiary'>
			{/* Left side: icon + text */}
			<div className='flex items-center gap-3'>
				<div>
					<img src='/images/Socrates_ikon.png' alt='Socrates illustration' className='max-h-10' />
				</div>
				<div className='flex flex-col'>
					<p className='text-base font-medium text-on-secondary leading-[1.4] tracking-[0.02em]'>
						{t('result_page.response_app_name', { app_name: t('general.app_name') })}
					</p>
					<p className='text-xs text-on-secondary leading-[1.2]'>
						{t('result_page.reading_time', { count: estimatedReadingTime })}
					</p>
				</div>
			</div>

			{/* Right side: button */}
			{isBrowserSupported && !print && (
				<div className='flex flex-col items-end'>
					<Button
						disabled={!isBrowserSupported}
						variant='tertiary'
						size='small'
						type='line'
						onClick={() => {
							if (!isSpeaking) {
								speak(content);
							} else {
								cancel();
							}
						}}
					>
						{isSpeaking ? t('speech.stop') : t('speech.speak')}
					</Button>
				</div>
			)}
		</div>
	);
};

ResultHeader.propTypes = {
	content: PropTypes.string.isRequired,
	print: PropTypes.bool,
};

export default ResultHeader;
